import React, { useEffect, useState } from 'react'
import { Form, Button, notification, Drawer, Input, Col, Row } from 'antd'
import { useDispatch } from 'react-redux'
import {countryIds, InputBox, Intakes, ProgramLevel, countryCurrencyObject} from '../../../components/_utils/appUtils'
import { listAllCountries } from '../../countries/actions/countries'
import { listQuickSearchUniversities } from '../../university/actions/university'
import { addContract } from '../actions/contract'
import moment from 'moment'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import AgentTypeheadComponent from "../../../components/_utils/AgentTypeheadComponent";


const AddContract = (props) => {
  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue },
    visible,
    events,
    universityTypeList,
    data,
    contractWith
  } = props
  const dispatch = useDispatch()
  let [allCountry, setAllCountry] = useState([])
  let [countryUniversity, setCountryUniversity] = useState([])
  let [contract, setContract] = useState({})
  let [oldContract, setOldContract] = useState({})
  let [mediaKey, setMediaKey] = useState(moment())
  let [contractData, setContractData] = useState({})
  let [agentId, setAgentId] = useState('')
  const chooseFiles = (files) => {
    setContract(files)
  }

  const chooseOldFiles = (files) => {
    setOldContract(files)
  }


  const appEvents = {
    loadCountry: async () => {
      let filters = {
        sortField: 'countryName', sortOrder: 'ascend',
        results: 100,
        count: 100,
        active: [false, true]
      }
      let { data } = await dispatch(listAllCountries(filters))
      setAllCountry(data)
    },
    loadUniversity: async (item) => {
      let obj = {
        results: 1000000,
        universityCountry: item,
        sortField: 'universityName',
        sortOrder: 'ascend'
      }
      let data = await dispatch(listQuickSearchUniversities(obj))
      setCountryUniversity(data)
    }
  }

  useEffect(() => {
    appEvents.loadCountry()
  }, [])

  useEffect(() => {
    if (data && data.countryId && data.countryId._id) {
      setContractData(data)
      appEvents.loadUniversity(data.countryId._id)
      setTimeout(() => {
        setFieldsValue({
          countryId: data.countryId._id,
          universityType: data.universityType,
          details: data.details
        })
      }, 100)

      setTimeout(() => {
        if (data.universityType === 'alreadyAdded' && data.universityId._id && data.universityId._id) {
          setFieldsValue({
            universityId: data.universityId._id
          })
        } else {
          setFieldsValue({
            universityName: data.universityName
          })
        }
      }, 300)

    }
  }, [data])


  let inputTypes = {
    fields: [
      {
        key: 'countryId',
        label: 'Country',
        required: true,
        type: 'select',
        showSearch: true,
        options: allCountry,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.countryName}`,
        onChange: x => {
          const currencyCode = Object.keys(countryCurrencyObject).find(
              key => countryCurrencyObject[key] === x.countryName
          )
          setFieldsValue({
            countryId: x,
            universityId: undefined,
            currency: currencyCode || undefined
          })
          appEvents.loadUniversity(x)
        }
      },

      {
        key: 'universityType',
        label: 'University Type',
        required: true,
        type: 'select',
        showSearch: true,
        options: universityTypeList,
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          setFieldsValue({
            universityType: x,
            universityId: undefined,
            universityName: undefined
          })
        }
      },
      {
        key: 'universityId',
        label: 'University',
        required: true,
        type: 'select',
        showSearch: true,
        hidden: !(getFieldValue('universityType') === 'alreadyAdded'),
        options: countryUniversity,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.universityName}`,
        onChange: x => setFieldsValue({ universityId: x })
      },
      {
        key: 'universityName',
        label: 'University',
        required: true,
        placeholder: 'University',
        hidden: !(getFieldValue('universityType') === 'other')
      },
      {
        key: 'originalStartDate',
        label: 'Original Start Date',
        type: 'date',
        required: true
      },
      {
        key: 'startDate',
        label: 'Start Date',
        type: 'date',
        required: true
      },
      {
        key: 'endDate',
        label: 'End Date',
        type: 'date',
        required: true
      },
      {
        label: 'Old Contract',
        customField: (
            <InputBox title={'* Old Contract'} className={'rowFlex'} customStyle={{ marginTop: 10 }}>
              <Input
                  type={'file'}
                  name={'oldContract'}
                  id={'oldContract'}
                  key={mediaKey}
                  className={'form-control'}
                  onChange={(e) => chooseOldFiles(e.target.files[0] || null)}
              />
            </InputBox>
        )
      },
      {
        label: 'Contract',
        customField: (
            <InputBox title={'* Contract'} className={'rowFlex'} customStyle={{ marginTop: 10 }}>
              <Input
                  type={'file'}
                  name={'contract'}
                  id={'contract'}
                  key={mediaKey}
                  className={'form-control'}
                  onChange={(e) => chooseFiles(e.target.files[0] || null)}
              />
            </InputBox>
        )
      },
      {
        key: 'contractType',
        label: 'Contract Type',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Direct', 'Third Party', 'Exclusive', 'Other'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ contractType: x })
      },
      {
        key: 'contractWith',
        label: 'Contract With',
        required: true,
        type: 'select',
        showSearch: true,
        options: contractWith,
        keyAccessor: x => x.name,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          setFieldsValue({
            contractWith: x
          })
        }
      },

      {
        key: 'registeredNumber',
        label: 'Registered Number'
      },
      {
        key: 'registeredEmailId',
        label: 'Registered Email ID'
      },
      {
        key: 'repEmailId',
        label: 'Rep. Email ID',
        required: true,
        type: 'email'
      },
      {
        key: 'representativeName',
        label: 'Representative Name',
        required: true
      },
      {
        key: 'repContactNumber',
        label: 'Rep. Contact Number',
        required: true
      },
      {
        key: 'additionalContactName',
        label: 'Additional Contact Name'
      },
      {
        key: 'additionalContactNumber',
        label: 'Additional Contact Number'
      },
      {
        key: 'additionalContactEmail',
        label: 'Additional Contact Email',
        type: 'email'
      },
      {
        key: 'commissionStructure',
        label: 'Commission Structure',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Slab %', 'Fixed', 'Other'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ commissionStructure: x })
      },
      {
        key: 'commissionToUniz',
        label: 'Commission - Uniz',
        required: true,
        type: 'text'
      },
      {
        key: 'commissionToPartners',
        label: 'Commission - To Partners',
        required: true,
        type: 'text'
      },
      {
        key: 'currency',
        label: 'Currency',
        required: true,
        type: 'select',
        showSearch: true,
        options: Object.keys(countryCurrencyObject).map(code => ({
          code,
          country: countryCurrencyObject[code]
        })),
        keyAccessor: x => x.code,
        valueAccessor: x => `${x.code} - ${x.country}`,
        onChange: x => setFieldsValue({ currency: x })
      },
      {
        key: 'totalTarget',
        label: 'Total Target',
        type: 'text'
      },
      {
        key: 'uniwiseTarget',
        label: 'UniWise Target',
        type: 'text'
      },
      {
        key: 'minEnrolments',
        label: 'Min Enrolments',
        type: 'text'
      },
      {
        key: 'northIndia',
        label: 'North India',
        type: 'text'
      },
      {
        key: 'restOfIndia',
        label: 'Rest Of India',
        type: 'text'
      },
      {
        key: 'international',
        label: 'International',
        type: 'text'
      },
      {
        key: 'targetVsAchieved',
        label: 'Target vs Achived',
        type: 'text'
      },
      {
        key: 'trainingStatus',
        label: 'Training Status',
        required: true
      },
      {
        key: 'trainingDate',
        label: 'Training Date',
        type: 'date'
      },
      {
        key: 'applicableRegions',
        label: 'Applicable Regions',
        type: 'text',
      },
      {
        key: 'programLevel',
        label: 'Program Level',
        showSearch: true,
        type: 'select',
        mode: 'multiple',
        options: ProgramLevel,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: programLevel => setFieldsValue({ programLevel })
      },
      {
        key: 'intake',
        label: 'Intake',
        type: 'select',
        showSearch: true,
        mode: 'multiple',
        options: Intakes,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: intake => setFieldsValue({ intake })
      },
      {
        key: 'under18',
        label: 'Under 18 ',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Yes', 'No'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ under18: x })
      },
      {
        label: 'Change of Agent',
        customField: (
            <InputBox title={'Change of Agent'} className={'rowFlex'} customStyle={{ marginTop: 10 }}>
              <AgentTypeheadComponent
                  key={agentId}
                  agentId={agentId}
                  dispatch={dispatch}
                  customStyle=""
                  onSelect={item => setAgentId(item)}
                  blockStatus={false}
              />
            </InputBox>
        )
      },
      {
        key: 'campus',
        label: 'Campus',
        required: false
      },
      {
        key: 'details',
        label: 'Notes',
        type: 'textarea',
        span: 24
      }
    ]
  }


  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let obj = {
         ...valData,
          agentId: agentId || undefined
        }
        if (contractData && contractData._id) {
          obj.pendingUniversityContractId = contractData._id
        }
        let fd = new FormData()
        fd.append('obj', JSON.stringify(obj))
        if (!contract || (contract && !contract.name)) {
          notification.warning({ message: 'Please Choose contract.' })
          return
        }
        // if (!oldContract || (oldContract && !oldContract.name)) {
        //   notification.warning({ message: 'Please choose old contract.' })
        //   return
        // }

        if (contract) {
          fd.append('contract', contract, contract.name)
        }

        if (oldContract) {
          fd.append('oldContract', oldContract, oldContract.name)
        }

        let data = await dispatch(addContract(fd))
        if (data && !data.error) {
          setContractData({})
          form.resetFields()
          setMediaKey(moment())
        }
        events.hideDrawer()
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }


  return (
    <Drawer
      visible={visible}
      width={'85%'}
      placement='right'
      onClose={events.hideDrawer}
      title={'Add New Contract'}>
      <div className='form-box'>
        <div className='card unizportal'>
          <Form onSubmit={handleSubmit}>
            <Row gutter={16} className={'wrapBox'}>
              {inputTypes.fields.map((item, key) => {
                return (
                  <React.Fragment key={key}>
                    {item.customField ?
                      <Col span={item.span ? item.span : 6}>
                        {item.customField}
                      </Col>
                      :
                      !item.hidden && <Col span={item.span ? item.span : 6} key={key}>
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout} />
                      </Col>}
                  </React.Fragment>
                )
              })}
            </Row>
            <Form.Item style={{ marginTop: 25 }}>
              <Button type='primary' htmlType='submit' className={'btn'}>
                ADD
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Drawer>
  )
}
const WrappedCountry = Form.create()(AddContract)
export default WrappedCountry
